import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f8a9bb80")

_pushScopeId("data-v-f8a9bb80")
const _hoisted_1 = { style: {"padding":"5px 0 0 45px"} }
const _hoisted_2 = /*#__PURE__*/_createVNode("span", null, "元/坐席/月", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("span", null, "分钟", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_a_input_number = _resolveComponent("a-input-number")
  const _component_a_form_item = _resolveComponent("a-form-item")
  const _component_a_col = _resolveComponent("a-col")
  const _component_a_row = _resolveComponent("a-row")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: _ctx.size != 'small' && 'title'
    }, "开通套餐包", 2),
    _createVNode(_component_a_row, { gutter: 4 }, {
      default: _withId(() => [
        _createVNode(_component_a_col, { span: 14 }, {
          default: _withId(() => [
            _createVNode(_component_a_form_item, {
              label: "套餐费用",
              "label-col": { span: 7 },
              "wrapper-col": { span: 16 },
              style: { marginBottom: _ctx.size != 'small' ? '24px' : '0' }
            }, {
              default: _withId(() => [
                _createVNode(_component_a_input_number, {
                  size: _ctx.size,
                  min: 0,
                  value: _ctx.money,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.money = $event)),
                  precision: 2
                }, null, 8, ["size", "value"]),
                _hoisted_2
              ]),
              _: 1
            }, 8, ["style"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, { span: 10 }, {
          default: _withId(() => [
            _createVNode(_component_a_form_item, {
              label: "通话时长",
              "label-col": { span: 8 },
              "wrapper-col": { span: 16 },
              style: { marginBottom: _ctx.size != 'small' ? '24px' : '0' }
            }, {
              default: _withId(() => [
                _createVNode(_component_a_input_number, {
                  size: _ctx.size,
                  min: 0,
                  value: _ctx.timeMinute,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_ctx.timeMinute = $event)),
                  precision: 0
                }, null, 8, ["size", "value"]),
                _hoisted_3
              ]),
              _: 1
            }, 8, ["style"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
})